<template>
  <div class="page-content" id="ruleExplain">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>信用积分</el-breadcrumb-item>
      <el-breadcrumb-item>信用积分规则</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <h3>授权店铺信用积分扣分规则与说明</h3>
      <div class="subtitle_common_bold">
        <span>信用积分周期</span>
      </div>
      <div v-if="credit.message">
        <div class="f16">
          {{ credit.type == '4' ? '自定义整年' : 
             credit.type == '3' ? '自定义半年' : 
             credit.type == '2' ? '自定义季度' : '未知周期' }}
        </div>
        <p class="c6">{{ credit.message }}</p>
      </div>
      <div v-else>
        <div class="f16">{{ typeList[Number(credit.type) - 1].title }}</div>
        <p class="c6">{{ typeList[Number(credit.type) - 1].info }}</p>
      </div>
      <div class="subtitle_common_bold">
        <span>总分值</span>
      </div>
      <div class="f16">{{ credit.score }}分</div>
      <div class="subtitle_common_bold">
        <span>积分规则说明</span>
      </div>
      <p style='white-space: pre-line;'>{{ credit.describe }}</p>
    </section>
  </div>
</template>
<script>
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState } from "vuex";

export default {
  data() {
    return {
      credit: { type: 1 }
    };
  },
  mounted() {
    this.getInstallList(); //信用总积分初始化
  },
  computed: {
    ...mapState({
      typeList: state => state.creditScore.typeList
    })
  },
  methods: {
    getInstallList() {
      fetchGet("hcm/hcmReport/getInstallListByReportId", { type: 1 }).then(
        res => {
          if (res.status == "10000") {
            if (res.data) {
              this.credit = res.data;
            }
          }
        }
      );
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";

#ruleExplain {
  .subtitle_common_bold {
    margin-top: 50px;
  }

  .seaerch-wrapper {
    padding: 20px 24px;
  }
}
</style>
